// Format milliseconds as M:SS.cs (e.g. 1:23.45) for the speedrun timer.
export function formatTime(ms) {
  if (ms == null || isNaN(ms)) return "0:00.00";
  const total = Math.max(0, Math.round(ms));
  const m = Math.floor(total / 60000);
  const s = Math.floor((total % 60000) / 1000);
  const cs = Math.floor((total % 1000) / 10);
  return `${m}:${String(s).padStart(2, "0")}.${String(cs).padStart(2, "0")}`;
}
